// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from "../../common";
import api from '../../../services/api'
import { callbackProps, ID } from "../../../constants";
import { SET_STUDENT_LIST } from "../types";
import { SET_TASK_COMPLETED } from '../../onboarding/actions';
import { store } from '../../ROOT/store';

const actionGetStudents = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_STUDENT_LIST),
  api: api.getStudents,
  payload: { data: new URLSearchParams(payload) },
  callback,
});
const actionDeleteStudent = (
  payload:ID,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.deleteStudent,
  payload: { data: payload },
  callback,
});

const actionAddStudent = (
    payload: any,
    callback?: (a: callbackProps) => void
): requestActionProps => ({
    type: requestGenerate(Types.REQUEST),
    api: api.addStudent,
    payload: { data: payload },
    callback: (response: any) => {
        if (response.status === 200) {
            store.dispatch({ type: SET_TASK_COMPLETED, payload: 'studentsAdded', value: true });
            // Öğrenci başarıyla eklendiğinde listeyi güncelle
            store.dispatch(actionGetStudents({classroomId: payload.classroomId}));
        }
        callback && callback({ type: 'SUCCESS', payload: response });
    }
});

const actionAddMultipleStudents = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.addMultipleStudents,
  payload: { data: payload },
  callback: (response: any) => {
    if (response.status === 200) {
        console.log('successfull test', response);
      store.dispatch({ type: SET_TASK_COMPLETED, payload: 'studentsAdded', value: true });
      // Öğrenciler başarıyla eklendiğinde listeyi güncelle
      store.dispatch(actionGetStudents({classroomId: payload.classroomId}));
    }
    callback && callback({ type: 'SUCCESS', payload: response });
  }
});

export {
  actionGetStudents,
  actionDeleteStudent,
  actionAddStudent,
  actionAddMultipleStudents
};
